
export default {
  name: 'SubHeader',
  props: {
    title: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '188px',
    },
  },
}
